import { Modal, ModalContainer } from "@aviary";

import { QuickViewSingleProductDetails } from "../../SingleProductDetails/QuickViewSingleProductDetails";

interface Props {
  isOpen: boolean;
  productId: string | null;
  onClose: () => void;
}

const QuickViewModal = ({ isOpen, productId, onClose }: Props) => {
  return (
    <Modal size="xlarge" isOpen={isOpen} onClose={onClose}>
      <ModalContainer>
        {!!productId && <QuickViewSingleProductDetails productId={productId} />}
      </ModalContainer>
    </Modal>
  );
};

export { QuickViewModal };
